import cn from "classnames";
import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import { PaymentIcons } from "components/shared/PaymentIcons";
import { Button } from "components/UI/Buttons/Button";
import { upperFirst } from "lodash";
import { useCallback } from "react";
import styles from "./SectionPayments.module.scss";

export type SectionPaymentsProps = {
  type?: "primary" | "secondary";
  divider?: "top" | "bottom";
  heading: string;
  subheading?: string;
  button: {
    text: string;
    href: string;
  };
  buttonText?: string;
};

export const SectionPayments = ({
  heading,
  subheading,
  button,
  buttonText,
  type = "primary",
  divider,
}: SectionPaymentsProps) => {
  const actionButton = useCallback(
    () => (
      <div className={styles.action}>
        <Button href={button.href} size="fullwidth">
          {button.text}
        </Button>
        {buttonText && <p className={styles.bottomText}>{buttonText}</p>}
      </div>
    ),
    [button, buttonText]
  );

  return (
    <section className={cn(styles.section, styles[`type${upperFirst(type)}`])}>
      <Container divider={divider} className={styles.container}>
        <div className={styles.inner}>
          <Heading
            align={type === "primary" ? "center" : "left"}
            title={heading}
            subheading={subheading}
            className={styles.heading}
          />
          <div className={styles.bottom}>
            <PaymentIcons size={type === "primary" ? "big" : "small"} className={styles.icons} />
            {type === "primary" ? actionButton() : ""}
          </div>
        </div>
        {type === "secondary" ? actionButton() : ""}
      </Container>
    </section>
  );
};

export default SectionPayments;
